import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {connect} from 'react-redux'
import { Link } from 'react-router';
import { getRequiredCreditsToProceed, getCurrentSelectionWeight } from '../common/utils'

const StudentSteps = ({
  tempEnableReviewButton = false,
  coursesToAdd = [],
  student: {
    max_course_units // this is labeled "target credits" in the UI
    // target_course_units // this is labeled "minimum credits" in the UI
  },
  run: {
    is_eliciting = false
    // assignment_complete = false
  },
  active = 0
 }) => {
   // @TODO this should be in redux, not localstorage
  let run = localStorage.getItem('run');

  const isButtonDisabled = {
    // get started (0)
    0: {
      0: true, // disable on self
      1: false,
      2: false,
      3: false,
      4: false
    },
     // find classes (1)
    1: {
      0: !(is_eliciting && max_course_units),
      1: true, // disable on self
      2: false,  // can always go back from rank -> find
      3: false, // not sure why this used to disable here!target_course_units,
      4: false
    },
    // rank clases (2)
    2: {
      0: true,
      1: getCurrentSelectionWeight(coursesToAdd) < getRequiredCreditsToProceed(max_course_units),
      2: true, // disable on self
      3: false,
      4: false
    },
    // review schedules
    3: {
      0: !tempEnableReviewButton,
      1: !tempEnableReviewButton,
      2: true, // getCurrentSelectionWeight(coursesToAdd) < getRequiredCreditsToProceed(max_course_units),
      3: !tempEnableReviewButton, // disable on self
      4: false
    },
    // confirmation
    4: {
      0: true,
      1: true,
      2: true,
      3: false,
      4: true // disable on self
    }
  }

  // ** the getting started button is always enabled
  const renderGetStartedButton = () => {
    return (
      <Link
        to={`/rank/${run}/start`}
        className={classNames('btn', 'btn-ter', { active: active === 0, disable: isButtonDisabled[0][active] })}
      >
        {'Get Started'}
      </Link>
    )
  }
  
  // ** I think this button is used in two places, so be careful with active = {active_page_index}
  // ** enabled on [1,2]
  // ** 0 - !(this.props.run.is_eliciting && this.props.student.max_course_units)
  // ** 3 - this.props.student.target_course_units == null
  const renderFindClassesButton = () => {
    return (
      <Link
        to={`/rank/${run}/find`}
        className={classNames('btn', 'btn-ter', { active: active === 1, disable: isButtonDisabled[1][active] })}
        onClick={
          isButtonDisabled[1][active]
            ? function (e) {
              e.preventDefault();
            }
            : null
        }
      >
        Find Classes
      </Link>
    )
  }

  const renderRankClassesButton = () => {
    return (
      <Link
        to={`/rank/${run}/rank`}
        className={classNames('btn', 'btn-ter', { active: active == 2, disable: isButtonDisabled[2][active] })}
        onClick={
          isButtonDisabled[2][active]
            ? function (e) {
              e.preventDefault();
            }
            : null
        }
      >
        Rank Classes
      </Link>
    )
  }

  const renderReviewSchedulesButton = () => {
    return (
      <Link
        to={`/rank/${run}/schedules`}
        className={classNames('btn', 'btn-ter', { active: active === 3, disable: isButtonDisabled[3][active] })}
        onClick={
          isButtonDisabled[3][active]
            ? function (e) {
              e.preventDefault();
            }
            : null
        }
      >
        Review Schedules
      </Link>
    )
  }

  const renderConfirmButton = () => {
    return (
      <Link
        to={`/rank/${run}/confirm`}
        className={classNames('btn', 'btn-ter', { active: active === 4, disable: isButtonDisabled[4][active] })}
        onClick={
          isButtonDisabled[4][active]
            ? (e) => e.preventDefault() : null
        }
      >
        Confirm
      </Link>
    )
  }



  return (
    <div className="student-steps">
      {/* GET STARTED */}
      {renderGetStartedButton()}
      <i className="fa fa-long-arrow-right" />
      {/* FIND CLASSES */}
      {renderFindClassesButton()}
      <i className="fa fa-long-arrow-right" />
      {/* RANK CLASSES */}
      {renderRankClassesButton()}
      <i className="fa fa-long-arrow-right" />
      {/* REVIEW SCHEDULE */}
      {renderReviewSchedulesButton()}
      <i className="fa fa-long-arrow-right" />
      {/* CONFIRM */}
      {renderConfirmButton()}
    </div>
  )
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses,
    coursesToAdd: state.general.coursesToAdd
  };
}

function mapDispatchToProps(/*dispatch*/) {
  return {
    // runActions: bindActionCreators(runActions, dispatch),
    // studentActions: bindActionCreators(studentActions, dispatch),
    // coursesActions: bindActionCreators(coursesActions, dispatch)
  };
}

StudentSteps.propTypes = {
  active: PropTypes.number.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentSteps);



// WEBPACK FOOTER //
// ./src/components/common/StudentStepsNew.js